var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marker-action"},[_c('list-action-form',{ref:"form",attrs:{"ids":_vm.ids,"labels":_vm.labels,"route":_vm.route,"method":_vm.method},on:{"submitted":_vm.submit}},[_c('input',{attrs:{"type":"hidden","name":"moderation_status"},domProps:{"value":_vm.status}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }